export enum ValueSelectionType {
  Median = 0
}

export const ValueSelectionTypeMapping: Record<ValueSelectionType, string> = {
  [ValueSelectionType.Median]: 'Median'
};
